import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { PhoneRegisterComponent } from './containers/phone-register.component';
import { PhoneRegisterEffects } from './state/phone-register.effects';
import { phoneRegisterFeatureKey, phoneRegisterReducer } from './state/phone-register.reducer';
import { PhoneRegisterViewComponent } from './views/phone-register-view.component';

@NgModule({
   declarations: [PhoneRegisterComponent, PhoneRegisterViewComponent],
   exports: [PhoneRegisterComponent, PhoneRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      EffectsModule.forFeature([PhoneRegisterEffects]),
      StoreModule.forFeature(phoneRegisterFeatureKey, phoneRegisterReducer),
   ],
})
export class PhoneRegisterModule {}
